import analytics from "../analytics/analytics.js";
const updatePennyDebugger = (submitChatMessagesPayload, chatMessages, headers)=>{
    if ('undefined' == typeof window) return;
    try {
        const indexedDB = window.indexedDB;
        const openRequest = indexedDB.open('PennyDB', 2);
        openRequest.onupgradeneeded = function(event) {
            const db = event.target.result;
            if (!db.objectStoreNames.contains('PennyDBStore')) {
                const objectStore = db.createObjectStore('PennyDBStore');
                objectStore.createIndex('pblb', 'pblb', {
                    unique: false
                });
            }
        };
        openRequest.onsuccess = function(e) {
            const db = e?.target?.result;
            if (db) {
                db.onerror = function(event) {
                    analytics.log({
                        source: 'updatePennyDebugger',
                        message: `Error occurred in writing data ${event.target.errorCode}`
                    });
                };
                const transaction = db.transaction([
                    'PennyDBStore'
                ], 'readwrite');
                const objectStore = transaction.objectStore('PennyDBStore');
                const request = objectStore.put({
                    data: {
                        submitChatMessagesPayload,
                        chatMessages,
                        headers
                    }
                }, 'pblb');
                request.onsuccess = function(e) {
                    analytics.log({
                        source: 'updatePennyDebugger',
                        message: 'Data has been written successfully'
                    });
                };
                request.onerror = function(e) {
                    analytics.log({
                        source: 'updatePennyDebugger',
                        message: `Error occurred in writing data ${e}`
                    });
                };
            }
        };
        openRequest.onerror = function(e) {
            analytics.log({
                source: 'updatePennyDebugger',
                message: `Error occurred in opening database ' ${e}`
            });
        };
    } catch (e) {
        analytics.log({
            source: 'updatePennyDebugger',
            message: `Error occurred in opening database ' ${e}`
        });
    }
};
export { updatePennyDebugger };
